import { AvailableGiftDTO, CouponGiftDTOGiftTypeEnum } from 'probonio-shared-ui/api';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNewDialogState } from '../../../component/dialog/BasicDialog';
import GiftModal from './GiftModal';
import { GiftNavButton } from './GiftNavButton';

interface Props {
  gift: AvailableGiftDTO;
}

export const GiftButton: React.FC<Props> = ({ gift }) => {
  const { dialogState, handleOpen: handleOpenDialog } = useNewDialogState();
  const { t } = useTranslation('benefitModule');
  const navigate = useNavigate();

  const handleConfirm = useCallback(() => {
    navigate('/coupons/explore-coupons', { state: gift });
  }, [gift, navigate]);

  return (
    <>
      <GiftNavButton onClick={handleOpenDialog} gift={gift} />
      <GiftModal
        gift={gift}
        dialogState={dialogState}
        infoMessage={t(
          gift?.giftType === CouponGiftDTOGiftTypeEnum.Incentive
            ? 'benefit.INCENTIVES.giftsModal.infoMessage'
            : 'benefit.GIFTS.giftsModal.infoMessage',
          { amount: gift.amount },
        )}
        onConfirm={handleConfirm}
      />
    </>
  );
};
